import { Col, Row } from "react-bootstrap";
import './CommonInput.scss';
const CommonInput = ({ label, labelRight, type, placeholder, coin, coinName, rightBtnTitle, onClickRightBtn, error,
    errorRef, ...rest } : { label?: string; labelRight?: string; type?: string; placeholder?: string; coin?: any; coinName?: string; rightBtnTitle?: string; onClickRightBtn?: any; error?: any; errorRef?: any;}) => {
    return (
        <div className={`common_input ${false ? "error" : ""}`}>
            <Row>
                <Col>
                    <label htmlFor={label}>{label}</label>
                </Col>
                {labelRight && <Col><span className="common_input_rightlabel">{labelRight}</span></Col>}
            </Row>
            <div className="common_input_inner">
                {coin && <div className="common_input_inner_token">
                    <img src={coin} alt="icon" />
                    <span>{coinName}</span>
                </div>
                }
                <div className={`common_input_inner_right ${coin ? coin : "nocoin"}`}>
                    <input type={type ? type : "text"} placeholder={placeholder} id={label} />
                    {rightBtnTitle && <button type="button" onClick={onClickRightBtn}>{rightBtnTitle}</button>}
                </div>
            </div>
            {error && <span ref={errorRef} {...rest} className="common_input_error">{error}</span>}
        </div>
    )
}

export default CommonInput